import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27 3.99911C27.5128 3.99911 27.9355 4.38516 27.9933 4.88249L28 4.99911V20.9991C28 21.512 27.614 21.9346 27.1166 21.9924L27 21.9991H21.9999V26.9993C21.9999 27.5121 21.6138 27.9348 21.1165 27.9925L20.9999 27.9993H4.99988C4.48704 27.9993 4.06437 27.6132 4.00661 27.1159L3.99988 26.9993V10.9993C3.99988 10.4864 4.38592 10.0638 4.88326 10.006L4.99988 9.99926L9.99988 9.99911L10 4.99911C10 4.48628 10.386 4.06361 10.8834 4.00584L11 3.99911H27ZM19.999 25.999V11.999H5.999V25.999H19.999ZM11.999 5.99899H25.999V19.999L21.9999 19.9991V10.9993L21.9932 10.8826C21.9354 10.3853 21.5127 9.99926 20.9999 9.99926L11.9999 9.99911L11.999 5.99899Z"
	})
});
export default SvgCopy;
